import { select } from "../core/dom";

export function initHeaderVisibility(): void {
  const wrapper = select<HTMLElement>(".header-wrapper");
  const menuCheckbox = select<HTMLInputElement>(".menu-checkbox");
  if (!wrapper) return;

  let previousScrollY = window.scrollY;
  let scheduled = false;

  const update = (): void => {
    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > previousScrollY;

    if (menuCheckbox?.checked) {
      wrapper.classList.remove("is-hidden");
    } else {
      wrapper.classList.toggle("is-hidden", isScrollingDown && currentScrollY > 80);
    }

    previousScrollY = currentScrollY;
    scheduled = false;
  };

  window.addEventListener(
    "scroll",
    () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    },
    { passive: true }
  );
}
